module.exports = __webpack_public_path__ + "img/extended.7e4bb944.png";